import React, { useEffect, useState } from 'react'
import './css/LoginPage1.css'
import axios from 'axios';
import { useForm } from 'react-hook-form';
import { Form, Button } from 'react-bootstrap';
import { Link, useHistory } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { PhpToken, UserDetails } from '../../Actions';
import { Pageloader } from '../../Components/Pageloader';
import { Preloader } from '../../Components/Preloader';

export const Loginpage1 = ({ commonData, toast }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const d = new Date();
    const year = d.getFullYear();
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const LOGIN_BOTH = "B";
    const LOGIN_CRDENTIAL = "C";
    const LOGIN_OTP = "O";
    const LOGIN_DIRECT = "D";
    document.title = "Login Page";
    // page loaders
    const [pageloader, setPageLoader] = useState(true);
    const [submitloader, setSubmitLoader] = useState(false);
    //end here
    const [otpon, setotpOn] = useState(false);
    const [otpkey, setotpkey] = useState("");
    // store company details
    let compIntitial;
    if (localStorage.getItem("companyinfo") === null) {
        compIntitial = [];
    } else {
        compIntitial = JSON.parse(localStorage.getItem("companyinfo"));
    }
    // end store company details
    // get login page  details
    const [loginMethod, setLoginMethod] = useState("B");
    const [companyInfo, setcompanyInfo] = useState(compIntitial);
    useEffect(() => {
        async function getlogindata() {
            let url = commonData.siteurl + '/expo_access_api/Loginpagedetails/';
            const headers = {
                'content-type': 'multipart/form-data'
            };
            const res = await axios.post(url, {
                AUTHORIZEKEY: commonData.AuthorizeKey
            }, headers);
            if (res) {
                setLoginMethod(res.data[0].DATA.login_method)
                setPageLoader(false);
                localStorage.setItem("companyinfo", JSON.stringify(res.data[0].DATA.companydetails.Companyinfo));
                setcompanyInfo(res.data[0].DATA.companydetails.Companyinfo);
                if (localStorage.getItem("eusername")) {
                    setValue("email", localStorage.getItem("eusername"));
                }
                if (localStorage.getItem("epassword")) {
                    setValue("password", localStorage.getItem("epassword"));
                }
            }
        }
        getlogindata();

    }, [loginMethod]);
    // end  get login page  details


 

    //submit form
    const onSubmit = (data) => {

        setSubmitLoader(true);
        const otpmobile = data.otpmobile;
        if (otpmobile > 0) {
            async function sendotp() {
                let otpurl = commonData.siteurl + '/expo_access_api/checkmobileotp/';
                const headers = {
                    'content-type': 'multipart/form-data'
                };
                const otpres = await axios.post(otpurl, {
                    AUTHORIZEKEY: commonData.AuthorizeKey,
                    mobile: otpmobile
                }, headers);

                if (otpres.data[0].STATUS == "SUCCESS") {
                   // setotpkey(otpres.data[0].data);
                    setValue("otpnumbr", "");
                    setValue("otpkey",otpres.data[0].data);
                    setotpOn(true);
                    toast("SUCCESS", otpres.data[0].MSG, "success");
                    setSubmitLoader(false);

                } else {
                    toast("Error", otpres.data[0].MSG, "danger");
                    setSubmitLoader(false);
                }
            }
            sendotp();
        } else {
            async function processlogin() {

                const username = data.email;
                const password = data.password;
                const usertype = data.usertype;
                const remember = data.remember_me;
                if (username === "") {
                    toast("Error", "username can not be null", "danger");
                    setSubmitLoader(false);
                    return false;

                }
                if (password === "null" & loginMethod === LOGIN_CRDENTIAL) {
                    toast("Error", "username can not be null", "danger");
                    setSubmitLoader(false);
                    return false;

                }
                let otpurl = commonData.siteurl + '/virtualexpo_api/verifyLogin/';
                const headers = {
                    'content-type': 'multipart/form-data'
                };
                const loginres = await axios.post(otpurl, {
                    AUTHORIZEKEY: commonData.AuthorizeKey,
                    username: username,
                    password: password,
                    usertype: usertype
                }, headers);

                if (loginres.data[0].STATUS == "SUCCESS") {
                    if (remember === true) {
                        localStorage.setItem("eusername", username);

                        if (password !== "null" & (loginMethod === LOGIN_CRDENTIAL || loginMethod === LOGIN_BOTH)) {
                            localStorage.setItem("epassword", password);
                        }
                    }
                    toast("SUCCESS", loginres.data[0].MSG, "success");
                    setSubmitLoader(false);
                    if (loginres.data[0].DATA.expo_portal_disallow == "Y") {
                        history.push("/hold");

                    } else {
                        dispatch(PhpToken(loginres.data[0].PHPTOKEN));
                        dispatch(UserDetails(loginres.data[0].DATA));
                        if (localStorage.getItem("linklasturl")) {
                            console.log(localStorage.getItem("linklasturl"));
                            var urlSave = localStorage.getItem("linklasturl")
                            localStorage.setItem("linklasturl", "");
                            // window.open(urlSave);
                            history.push(urlSave);
                        } else {
                            history.push("/home");
                        }

                    }

                } else {
                    toast("Error", loginres.data[0].MSG, "danger");
                    setSubmitLoader(false);
                    if (loginres.data[0].DATA) {
                        if (loginres.data[0].DATA.msg == "unverified") {
                            setVerifyPage(true);
                        }
                        if (loginres.data[0].DATA.contact) {
                            setVerifyContact(loginres.data[0].DATA.contact);
                            generateotp(loginres.data[0].DATA.contact)
                        }
                    }
                }
            }
            processlogin();
        }


    }
    const [VerifyPage, setVerifyPage] = useState(false)
    const [VerifyContact, setVerifyContact] = useState("")
    //submit otp form
    const onotpSubmit = (data) => {
        setSubmitLoader(true);
        async function processlogin() {
            const otpkey = data.otpkey;
            const otpnumber = data.otpnumbr;
            const usertype = data.usertype;
            let otpurl = commonData.siteurl + '/virtualexpo_api/verifyLogin/';
            const headers = {
                'content-type': 'multipart/form-data'
            };
            const loginres = await axios.post(otpurl, {
                AUTHORIZEKEY: commonData.AuthorizeKey,
                otpkey: otpkey,
                otpnumber: otpnumber,
                usertype: usertype
            }, headers);

            if (loginres.data[0].STATUS == "SUCCESS") {
                toast("SUCCESS", loginres.data[0].MSG, "success");
                setSubmitLoader(false);
                if (loginres.data[0].DATA.expo_portal_disallow == "Y") {
                    history.push("/hold");
                } else {
                    dispatch(PhpToken(loginres.data[0].PHPTOKEN));
                    dispatch(UserDetails(loginres.data[0].DATA));
                    history.push("/home");
                }

            } else {
                toast("Error", loginres.data[0].MSG, "danger");
                setSubmitLoader(false);
                if (loginres.data[0].DATA) {
                    if (loginres.data[0].DATA.msg == "unverified") {
                        setVerifyPage(true);
                    }
                    if (loginres.data[0].DATA.contact) {
                        setVerifyContact(loginres.data[0].DATA.contact);
                        generateotp(loginres.data[0].DATA.contact)
                    }
                }
            }
        }
        processlogin();
    }

    const registerPush = () => {
        history.push("/register")
    }
    const minHeight = {
        minHeight: window.innerHeight

    }
    const [CPBlock, setCPBlock] = useState(false)
    const CPCancel = () => {
        setValue("remail", "");
        setCPBlock(false);
    }
    const onCPSubmit = (data) => {
        setSubmitLoader(true);
        async function processCP() {
            const remail = data.remail;
            const usertype = data.usertype;
            let otpurl = commonData.siteurl + '/expo_access_api/changePassword/';
            const headers = {
                'content-type': 'multipart/form-data'
            };
            const res = await axios.post(otpurl, {
                AUTHORIZEKEY: commonData.AuthorizeKey,
                remail: remail,
                usertype: usertype
            }, headers);

            if (res.data[0].STATUS == "SUCCESS") {
                toast("SUCCESS", res.data[0].MSG, "success");
                setSubmitLoader(false);
                setValue("remail", "");
                setCPBlock(false);

            } else {
                toast("Error", res.data[0].MSG, "danger");
                setSubmitLoader(false);
            }
        }
        processCP();
    }
    const [keyOT, setkeyOT] = useState("")
    const generateotp = (id) => {
        async function sendotp() {
            setSubmitLoader(true);
            const contact = id ? id : VerifyContact;
            let otpurl = commonData.siteurl + '/expo_access_api/verifyGenerateOTP/';
            const headers = {
                'content-type': 'multipart/form-data'
            };
            const loginres = await axios.post(otpurl, {
                AUTHORIZEKEY: commonData.AuthorizeKey,
                contact: contact
            }, headers);

            if (loginres.data[0].STATUS == "SUCCESS") {
                if (loginres.data[0].DATA) {
                    setkeyOT(loginres.data[0].DATA);

                }
                toast("SUCCESS", loginres.data[0].MSG, "success");
                setSubmitLoader(false);

            } else {
                toast("Error", loginres.data[0].MSG, "danger");
                setSubmitLoader(false);
            }
        }
        sendotp();

    }
    const onVerifyOTP = (data) => {

        async function verifyotp() {
            setSubmitLoader(true);
            const contact = VerifyContact;
            const number = data["verifyOTP"];

            let otpurl = commonData.siteurl + '/expo_access_api/verifyRegisterOTP/';
            const headers = {
                'content-type': 'multipart/form-data'
            };
            const loginres = await axios.post(otpurl, {
                AUTHORIZEKEY: commonData.AuthorizeKey,
                contact: contact,
                key: keyOT,
                verifyOTP: number
            }, headers);

            if (loginres.data[0].STATUS == "SUCCESS") {
                setVerifyPage(false);
                setotpOn(false);
                toast("SUCCESS", loginres.data[0].MSG, "success");
                setSubmitLoader(false);

            } else {
                toast("Error", loginres.data[0].MSG, "danger");
                setSubmitLoader(false);
            }
        }
        verifyotp();
    }
    return (
        <div>

            <div className="col-12 Mobileloginblock1 blueBg text-light" style={minHeight} >
                <div className="col-12 row login-view ">
                    <div className="login-form-block1">
                        {CPBlock === false
                            ?
                            <div className="company-name text-center py-1">
                                <Link to="/">
                                    <img className="imgLogo img-responsive" src="/images/global/LOGO_LOGON_PAGE.jpg" width="200" alt='logo_image' />
                                </Link>
                                <h3 className='fw-bold py-3'>Welcome  <span className='orangeColor fst-italic'> Visitor </span></h3>
                                <img className='my-1' src="/images/global/Blue-icon.jpg" />
                            </div>
                            :
                            <div className="company-name text-center py-1">
                                <Link to="/">
                                    <img className="imgLogo img-responsive" src="/images/global/LOGO_LOGON_PAGE.jpg" width="200" alt='logo_image' />
                                </Link>
                            </div>
                        }
                        {pageloader == true ?
                            <Pageloader />

                            :
                            [VerifyPage
                                ?
                                <Form id="register-form2" className="col-12 row m-0 py-5" onSubmit={handleSubmit(onVerifyOTP)}>
                                    <h2 className='text-center fw-bold py-2'> <span className="orangeColor">Verify it's you</span> </h2>
                                    <p className="text-light text-center ">
                                        Please enter the code sent on your <br />
                                        registered email/mobile number
                                    </p>
                                    <Form.Group className="mb-3" controlId="verifyOTP">
                                        <Form.Control className='text-center' type="text"  {...register('verifyOTP', {
                                            required: "OTP number is required"
                                        })} />
                                        <Form.Text className="text-muted">
                                            {errors.verifyOTP && <p className="text-danger">{errors.verifyOTP.message}</p>}
                                        </Form.Text>

                                    </Form.Group>
                                    <h4 onClick={() => { generateotp() }} className='orangeColor text-center text-decoration-underline cursor-pointer'>Resend code</h4>
                                    <div className="mt-4 text-center col-12 ">
                                        <Button className="btn-lg btnOrange loginBtn btn btn-primary" type="submit" disabled={submitloader} >
                                            Submit
                                        </Button>
                                    </div>
                                    <p className='orangeColor text-center py-3'>OTP code is valid for 10 minutes</p>
                                    <div className="text-center submitloader mt-3">
                                        {submitloader ?
                                            <>
                                                <Preloader />
                                            </>
                                            : ""
                                        }
                                    </div>
                                </Form>
                                :
                                [CPBlock === false
                                    ?
                                    [otpon === false ?
                                        <Form id="example-form" className="col-12 row m-0" onSubmit={handleSubmit(onSubmit)}>
                                            <Form.Control type="hidden" value="v"  {...register('usertype')} />
                                            <Form.Control type="hidden" value={loginMethod}  {...register('method', { required: "method is required" })} />
                                            {loginMethod == LOGIN_BOTH || loginMethod == LOGIN_CRDENTIAL || loginMethod == LOGIN_DIRECT ?
                                                <Form.Group className="mt-2 col-12" controlId="email">
                                                    <Form.Label>Enter your registered mobile number /  email id: </Form.Label>
                                                    <Form.Control type="text" placeholder="" {...register('email')} />
                                                    <Form.Text className="text-muted">
                                                        {errors.email && <p className="text-danger">{errors.email.message}</p>}
                                                    </Form.Text>
                                                </Form.Group> : ""
                                            }
                                            {loginMethod == LOGIN_BOTH || loginMethod == LOGIN_CRDENTIAL ?
                                                <Form.Group className="mt-2 col-12" controlId="password">
                                                    <Form.Label> Enter your password:  </Form.Label>
                                                    <Form.Control type="password" placeholder="" {...register('password')} />
                                                    <Form.Text className="text-muted">
                                                        {errors.password && <p className="text-danger">{errors.password.message}</p>}
                                                    </Form.Text>
                                                </Form.Group> : ""
                                            }
                                            {loginMethod == LOGIN_BOTH || loginMethod == LOGIN_CRDENTIAL || loginMethod == LOGIN_DIRECT ?
                                                <Form.Group className="mt-4" controlId="remember_me">
                                                    <Form.Check type="checkbox" label="Remember me" {...register('remember_me')} />
                                                    <a onClick={() => setCPBlock(true)} className='orangeColor fw-bold float-right'>Forgot Password</a>
                                                </Form.Group> : ""
                                            }

                                            {loginMethod == LOGIN_BOTH ? <div className="lonin-opt text-center mt-4"><h4 className="orangeColor fw-bold">Or login via OTP</h4></div> : ""}

                                            {loginMethod == LOGIN_BOTH || loginMethod == LOGIN_OTP ?
                                                <Form.Group className="mt-2 col-12" controlId="otpmobile">
                                                    <Form.Label> Enter your mobile number to Login:  </Form.Label>
                                                    <Form.Control type="number" placeholder="" {...register('otpmobile')} />
                                                    <Form.Text className="text-muted">
                                                        {errors.otpmobile && <p className="text-danger">{errors.otpmobile.message}</p>}
                                                    </Form.Text>
                                                </Form.Group> : ""
                                            }
                                            <div className="my-4 col-12 text-center">
                                                <Button className="btn-lg btnOrange" type="submit" disabled={submitloader} >
                                                    Submit
                                                </Button>
                                            </div>
                                            <div className="text-center submitloader mt-2">
                                                {submitloader ?
                                                    <>
                                                        <Preloader />
                                                    </>
                                                    : ""
                                                }
                                            </div>
                                        </Form>
                                        :
                                        <Form id="example-form1" className="col-12 row m-0 py-1" onSubmit={handleSubmit(onotpSubmit)}>
                                            <Form.Control type="hidden" value="v"  {...register('usertype')} />
                                            <Form.Control type="hidden" value={otpkey}  {...register('otpkey')} />
                                            <Form.Group className="mt-2 col-12" controlId="otpnumbr">
                                                <Form.Label> Enter your OTP number for verification:  </Form.Label>
                                                <Form.Control type="text" placeholder="please enter your number" {...register('otpnumbr', { required: "Please enter a valid number" })} />
                                                <Form.Text className="text-muted">
                                                    {errors.otpnumbr && <p className="text-danger">{errors.otpnumbr.message}</p>}
                                                </Form.Text>
                                            </Form.Group>
                                            <div className="mt-2 col-12 text-center">
                                                <Button onClick={()=>setotpOn(false)} className="btn-lg btnOrange mx-1" variant="primary" type="button" disable={submitloader} >
                                                    Back
                                                </Button>
                                                <Button className="btn-lg btnOrange" variant="primary" type="submit" disable={submitloader} >
                                                    Submit
                                                </Button>
                                            </div>
                                            <div className="text-center submitloader mt-3">
                                                {submitloader ?
                                                    <>
                                                        <Preloader />
                                                    </>
                                                    : ""
                                                }
                                            </div>
                                        </Form>
                                    ]
                                    :
                                    <div className="forgetPassRow pt-3">
                                        <h4 className='orangeColor pb-2 text-center'>Forget your Password?</h4>
                                        <p className='text-center  m-0'>Enter your registered Email address  or mobile number  </p>
                                        <p className='text-center  m-0'>to reset your password</p>
                                        <div className="inpuData py-2">
                                            <Form id="cp-form1" className="col-12 row m-0 py-4" onSubmit={handleSubmit(onCPSubmit)}>
                                                <Form.Group className="col-12" controlId="remail">
                                                    <Form.Label>Enter your register email or mobile number:  </Form.Label>
                                                    <Form.Control type="text"  {...register('remail', { required: "Required" })} />
                                                    <Form.Text className="text-muted">
                                                        {errors.remail && <p className="text-danger">{errors.remail.message}</p>}
                                                    </Form.Text>
                                                </Form.Group>
                                                <div className="my-4 col-12 text-center">
                                                    <Button onClick={() => CPCancel()} className="btn-lg outline-secondary loginBtn mx-2" variant="outline-light" disable={submitloader} >
                                                        Cancel
                                                    </Button>
                                                    <Button className="btn-lg btnOrange loginBtn" variant="primary" type='submit' disable={submitloader} >
                                                        Reset
                                                    </Button>
                                                </div>
                                                <div className="text-center submitloader mt-3">
                                                    {submitloader ?
                                                        <>
                                                            <Preloader />
                                                        </>
                                                        : ""
                                                    }
                                                </div>
                                            </Form>
                                        </div>
                                    </div>
                                ]
                            ]
                        }
                        {/* <div className="company-details1 py-1 text-center">
                    <h4>Contact us :</h4>
                    <h6>Email: {companyInfo.email_address}</h6>
                </div> */}

                    </div>

                </div>
                {CPBlock === false
                    ? <p className='text-center pb-5'>New user? <a onClick={() => registerPush()} className='orangeColor fw-bold'>Register</a> Here
                        <br />
                        <Link to="/adminpanel" className='orangeColor fw-bold'> Are you an Exhibitor ?</Link>
                    </p>
                    : ""
                }
                <footer className="text-center">
                    <div className="col-12 row">
                        <div className="col-12 text-center">
                            © {year} All right reserved by bharat expo.
                        </div>
                    </div>

                </footer>
            </div>
        </div>
    )
}
